import { MEETINGS_ORGANISATION_SLUG } from '@crm/contracts';
import type { Session } from '../../lib/session.tsx';

/** The meetings snapshot is Remote Leverage's Calendly, so the API serves it to no other organisation. */
export const showsCalendar = (session: Session) =>
  session.isEnabled('home.agenda') && session.me.organisation.slug === MEETINGS_ORGANISATION_SLUG;
